// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-story-slider{width:100%;height:100%}.frisbuy-story-slider .frisbuy-story-slide{width:100%;height:100%;background-position:50%;background-size:contain;background-repeat:no-repeat;position:absolute;top:0;left:0;bottom:0;right:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
